import { inject, Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { ToastProvider } from '@core';
import { InvestigationsApi } from '../../../infrastructure/api/investigations.api';
import type { ApproveInvestigationRequestCommand } from './approve-investigation-request.command';
import type { ApproveInvestigationRequestResult } from './approve-investigation-request.result';

@Injectable({ providedIn: 'root' })
export class ApproveInvestigationRequestUseCase {
  private readonly _api = inject(InvestigationsApi);
  private readonly _toast = inject(ToastProvider);

  public execute(command: ApproveInvestigationRequestCommand): Observable<ApproveInvestigationRequestResult> {
    const apiCall$ = command.isClosureApproval
      ? this._api.approveClosureRequest(command.investigationId, command.approvalRequestId)
      : this._api.approveRequest(command.investigationId, command.approvalRequestId);
    return apiCall$.pipe(
      tap(() => {
        this._toast.success(
          'Approved',
          'The approval request has been approved.',
        );
      }),
      map(() => ({ success: true })),
      catchError((error) => {
        this._toast.error(
          'Failed to approve',
          'Please try again or contact support if the issue persists.',
        );
        return throwError(() => error);
      }),
    );
  }
}
